<template>
  <div :class="{ 'thumb': true,
                 'selected': thumbSelected,
                 'm-3': true, }"
      v-if="!deleted"
      @click="setImage(imgkey, path)">
    <div class="delete"   @click="$bvToast.show(deleteToastName)">
      <b-icon-x-circle-fill aria-hidden="true"></b-icon-x-circle-fill>
    </div>
    <span class="toast-holder">
      <b-toast :id="deleteToastName" title="Confirm Delete" static auto-hide-delay="12000">
        <p>Delete this image?</p>
        <b-button
            variant="danger"
            @click.stop="deleteImage(imgkey)"
            class="m-1">
          <b-icon-trash aria-hidden="true"></b-icon-trash>
          Delete
        </b-button>
        <b-button
            variant="secondary"
            @click="$bvToast.hide(deleteToastName)"
            class="m-1">
            Cancel
        </b-button>
      </b-toast>
    </span>
    <b-img-lazy
        :src="path"
        alt=""
        height="100px"
        blank="true"
        blank-color="#ddd"
        blank-width="100px"
        rounded
    ></b-img-lazy>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { BIconXCircleFill, BIconTrash } from 'bootstrap-vue';
import axios from 'axios';

export default {
  name: 'ImageThumb',
  components: {
    BIconXCircleFill,
    BIconTrash,
  },
  props: {
    imgkey: String,
    path: String,
    idx: Number,
  },
  data() {
    return {
      deleted: false,
      deleteToastName: `delete-toast-${this.imgkey}`,
    };
  },
  computed: {
    selectedImage() {
      return this.imageToSelect[this.idx] || {};
    },
    thumbSelected() {
      return this.imgkey === this.selectedImage.key;
    },
    ...mapState(['config', 'imageToSelect']),
  },
  methods: {
    setImage(key, path) {
      // pick this image on click
      console.log('setImage', key);
      const img = { key, path };
      this.$store.commit('setImageToSelect', { image: img, bucket: this.idx });
    },
    deleteImage(key) {
      console.log('delete', key, this.config.objDeleteURL + key);
      this.$bvToast.hide(this.deleteToastName);
      axios.post(this.config.objDeleteURL + key)
        .then((response) => {
          console.log('deleted', response);
          if (this.selectedImage.key === key) {
            this.$store.commit('clearImageToSelect', this.idx);
          }
          this.deleted = true;
        })
        .catch((error) => {
          console.log(error);
          let errmsg = 'An unknown error occurred.';
          if (error.request) {
            console.log(error.request);
            if (error.response.status === 409) {
              errmsg = `Error: Image in use by design. (${error.response.status})`;
            } else {
              errmsg = `An error occurred: ${error.response.statusText} (${error.response.status})`;
            }
          } else if (error.response) {
            console.log(error.response);
            errmsg = 'Could not contact the server.';
          } else {
            console.log(error.message);
            errmsg = `An unknown error occurred: ${error.message}`;
          }
          this.$bvToast.toast(
            errmsg,
            {
              title: 'Delete Error',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 12000,
              variant: 'danger',
              solid: true,
            },
          );
        });
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumb {
  display: inline-block;
}

.thumb img {
  box-sizing: content-box;
  border-width: medium;
  border-style: solid;
  border-color: #00000000;
}

.selected img {
  border-color: orange;
}

.delete {
  display:block;
  position: relative;
  z-index: 10;
  height: 0;
  left: 6px;
  color: #AAAc;
  font-size: 1.4rem;
  width: 1.8rem;
  text-shadow: 1px 1px 2px red;
  cursor: pointer;
}

.toast-holder {
  display: block;
  position: fixed;
  z-index: 100;
}
</style>
